import GroupNodesSource from "../../types/groupNodesSource";
import addOrUpdateGroupNodesLabel from "../nodeRendering/addOrUpdateGroupNodesLabel";
export default (graphComponentRef, documentObjects, nodesSources, groupId, groupName, groupObjectCount, layout) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) ||
        !documentObjects ||
        !nodesSources ||
        !nodesSources.length)
        return undefined;
    const groupTag = new GroupNodesSource(groupId, nodesSources, documentObjects, layout.width, layout.height, groupName, groupObjectCount);
    const group = graphComponentRef.current.graph.createGroupNode({
        layout,
        tag: groupTag
    });
    addOrUpdateGroupNodesLabel(graphComponentRef, group);
    return group;
};
